
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8 7.058l3.3-3.3.943.943-3.3 3.3 3.3 3.3-.943.942-3.3-3.3-3.3 3.3-.942-.943 3.3-3.3-3.3-3.3.943-.942 3.3 3.3z","fill":"#EB3131"}})])
          )
        }
      }
    